require.register("confirmation/dataService", function(exports, require, module){
  $0
  
});

